module.exports = __webpack_public_path__ + "img/equipa_suporte.9c6f9b0d.png";